// 底层组件库
import barOption from "./components/bar";
import barlineOption from "./components/barline";
import datetimeOption from "./components/datetime";
import flopOption from "./components/flop";
import funnelOption from "./components/funnel";
import gaugeOption from "./components/gauge";
import iframeOption from "./components/iframe";
import imgOption from "./components/img";
import imgborderOption from "./components/imgborder";
import lineOption from "./components/line";
import mapOption from "./components/map";
import pictorialbarOption from "./components/pictorialbar";
import pieOption from "./components/pie";
import progressOption from "./components/progress";
import radarOption from "./components/radar";
import scatterOption from "./components/scatter";
import swiperOption from "./components/swiper";
import tableOption from "./components/table";
import tabsOption from "./components/tabs";
import textOption from "./components/text";
import videoOption from "./components/video";
import commonOption from "./components/common";
import wordcloudOption from "./components/wordcloud";
import demoOption from "./components/demo";
import vartextOption from "./components/vartext"; //通用配置

import mainOption from "./components/main"; //自定义组件库

import testOption from '@/components/test/option';
export default {
  components: {
    commonOption: commonOption,
    mainOption: mainOption,
    barOption: barOption,
    barlineOption: barlineOption,
    datetimeOption: datetimeOption,
    flopOption: flopOption,
    funnelOption: funnelOption,
    gaugeOption: gaugeOption,
    iframeOption: iframeOption,
    imgOption: imgOption,
    imgborderOption: imgborderOption,
    lineOption: lineOption,
    mapOption: mapOption,
    demoOption: demoOption,
    pictorialbarOption: pictorialbarOption,
    pieOption: pieOption,
    progressOption: progressOption,
    radarOption: radarOption,
    scatterOption: scatterOption,
    swiperOption: swiperOption,
    tableOption: tableOption,
    tabsOption: tabsOption,
    textOption: textOption,
    videoOption: videoOption,
    wordcloudOption: wordcloudOption,
    testOption: testOption,
    vartextOption: vartextOption
  }
};